import React from 'react';
import { GuestTestFlow } from '../components';

/**
 * Guest info collection page component that wraps GuestTestFlow
 * This provides a clean URL structure for guest test information collection
 */
const GuestInfo: React.FC = () => {
  return (
    <GuestTestFlow initialStep="info" />
  );
};

export default GuestInfo;